var React = require('react');

function Memory (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M640 130.94V96a32 32 0 0 0-32-32H32A32 32 0 0 0 0 96v34.94A47.86 47.86 0 0 1 32 176a47.86 47.86 0 0 1-32 45.06V320h640v-98.94a47.73 47.73 0 0 1 0-90.12zM224 256h-64V128h64zm128 0h-64V128h64zm128 0h-64V128h64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M224 128h-64v128h64zm128 0h-64v128h64zm128 0h-64v128h64zM0 352v96h64v-26.67a16 16 0 0 1 32 0V448h128v-26.67a16 16 0 1 1 32 0V448h128v-26.67a16 16 0 1 1 32 0V448h128v-26.67a16 16 0 1 1 32 0V448h64v-96z","className":"fa-primary","key":2})]);
}

Memory.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Memory;

Memory.default = Memory;
